export default __webpack_public_path__ + "static/media/background_home.600eb2fc.jpg";